import VenueCard from './VenueCard';
import VenueSplit from './VenueSplit';
import VenueCardRefined from './VenueCardRefined';
import VenueSplitLuxe from './VenueSplitLuxe';

const VARIANTS = {
  'venue-card': VenueCard,
  'venue-split': VenueSplit,
  'venue-card-refined': VenueCardRefined,
  'venue-split-luxe': VenueSplitLuxe,
};

export default function VenueSection({ section, data, theme, settings }) {
  const Variant = VARIANTS[section.variant] || VenueCard;
  return <Variant section={section} data={data} theme={theme} settings={settings} />;
}
